// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"app_login_login_module_ts":"65c562339b7864a5","app_release-notes_release-notes_module_ts":"1487a8e5f527176c"}[chunkId] + ".js";
};